export function ButtonGroup({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex [&>*:not(:first-child):not(:last-child)]:rounded-none [&>*:first-child]:rounded-r-none [&>*:last-child]:rounded-l-none">
      {children}
    </div>
  );
}
